<template>
	<div class="page-mdl">
		<!-- 选项卡切换 -->
		<div class="m-tag-box2">
			<span :class="{act:item.val==schoolType}" v-for="(item,index) in schoolTypeList" :key="index"
				@click="changeScreen('schoolType',item.val)">{{item.title}}</span>
			<!-- <span>本科院校</span>
			<span>高职高专</span>
			<span>开放大学</span> -->
		</div>
		
		<!-- 课程资源列表 -->
		<van-list
			v-if="listInfo.list.length>0"
			v-model="listInfo.loading" 
			:finished="listInfo.finished"
			finished-text="没有更多了" 
			:offset="30"
			@load="getCollegesList"
		>
			<ul class="school-list">
				<li v-for="(item,index) in listInfo.list" :key="index" @click="goDetail(item)">
					<div class="logo" :style="'background-image:url('+ (item.orgLogo || dfImg) +')'"></div>
					<h4>{{item.orgName}}</h4>
					<h5>{{item.orgEnName}}</h5>
					<p>{{item.courseCounts}}门课程  |  {{item.teacherCounts}}名教师</p>
				</li>
			</ul>
		</van-list>
		<van-empty v-if="listInfo.finished && !listInfo.list.length>0"  description="暂无找到匹配的课程" />

	</div>
</template>

</template>

<script>
import { getList } from '@/static/js/list-vant.js'
export default {
	data () {
		return {
			schoolTypeList:[
				{ title:'全部院校', val:'' },
				{ title:'本科院校', val:1 },
				{ title:'高职院校', val:2 },
				{ title:'成人高校', val:3 },
			],
			schoolType:'',	//院校类型:1本科院校 2高职院校 3成人高校
			orgName:'',
			
			detail:null,
			
			listInfo:{	//开放课程
				list:[],
				pageNum:1,
				pageSize:10,
				total:0,
				loading: true,
				finished: false,
			},
		}
	},
	
	async created(){
		await this.$onLaunched;		//监听加载了APP.vue中的onLaunched的异步后执行
		this.getCollegesList(true)
	},
  
	computed:{
		
	},
  
	methods:{
		//切换筛选类型
		changeScreen(typeName,val){
			if(typeName==this[typeName]){return}
			this[typeName] = val
			this.getCollegesList(true)
		},
		
		//获取院校列表
		getCollegesList(isReach){
			const { schoolType, orgName } = this
			getList({
				url:`/jxedu/api/site/findPartnersOrg`,
				page:this,				//必传,当前页面的this
				isReach,
				listName:'listInfo',
				data:{
					orgName,
					schoolType,	//院校类型:1本科院校 2高职院校 3成人高校
				},
				cbListFn:(res)=>{
					return res.data.rows	//这里接口返回的数据层级，看列表属于哪一级
				},
				handleFn:(item)=>{
					
				}
			})
		},
		
		
		//跳转详情
		goDetail(item){
			this.goUrl({name:'collegesDetail',params:{ id:item.orgId }})
		}
	}
}
</script>

<style lang="less" scoped>
@vm: 7.5vw;
.m-tag-box2{
	position:fixed; top:0; left:0; width:100%; box-sizing: border-box; z-index:10;
}

.school-list{
	padding:136/@vm 32/@vm 0; display:flex; justify-content: space-between; flex-wrap: wrap;
	li{
		width: 330/@vm;  box-sizing: border-box; transition: .3s all; margin-bottom:26/@vm;
		background: #FFFFFF; box-shadow: 0/@vm 2/@vm 14/@vm 0/@vm rgba(0, 0, 0, 0.1); border-radius: 6/@vm; border: 1/@vm solid #EEEEEE;
		border-radius: 4/@vm; text-align:center; padding:32/@vm 20/@vm 56/@vm 20/@vm; position:relative;
		.logo{ width:140/@vm; height:140/@vm; border-radius:100%; margin-bottom:24/@vm; }
		
		.logo{
			width:100%; height:140/@vm; margin-bottom:24/@vm; 
			background-size:contain; background-repeat:no-repeat; background-position:center center; 
		}
		h4{ font-size:30/@vm; color:#333333; line-height:44/@vm; font-weight: bold; margin-bottom:20/@vm;}
		h5{ font-size: 24/@vm; font-family: PingFangSC-Regular, PingFang SC; font-weight: 400; color: #999999; line-height: 30/@vm; min-height:48/@vm; margin-bottom:24/@vm;  }
		p{ font-size:24/@vm; line-height:24/@vm; color:#666666; position:absolute; left:0; bottom:30/@vm; width:100%; text-align: center;  }
		&:hover{
			 box-shadow: 0/@vm 2/@vm 18/@vm 0/@vm rgba(0, 0, 0, 0.16); 
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/colleges-list/tpl-mobile.vue